import React from 'react';
import { motion } from 'framer-motion';

const Marquee = () => {
  const text = "सेवा • संस्कार • समरसता • संगठन • पंचपरिवर्तन • विकसित भारत 2047 • ";
  const repeatedText = text.repeat(20);

  return (
    <section className="py-8 bg-gradient-to-r from-orange-500 via-orange-600 to-orange-500 overflow-hidden">
      <motion.div
        className="whitespace-nowrap flex"
        animate={{
          x: [0, -2000],
        }}
        transition={{
          x: {
            repeat: Infinity,
            repeatType: "loop",
            duration: 40,
            ease: "linear",
          },
        }}
      >
        <span 
          className="text-white text-2xl md:text-3xl font-bold inline-block"
          style={{ fontFamily: '"Noto Sans Devanagari", sans-serif' }}
        >
          {repeatedText}
        </span>
      </motion.div>
    </section>
  );
};

export default Marquee;